import React, { FC } from 'react';
import ThemedErrorMessage from '../../../../common/components/presentation/error/ThemedErrorMessage';
import { Box, Button, useTheme } from '@material-ui/core';
import Translation from '../../../../gqlCommon/components/translation/Translation';
import customiseErrorBoundaryStyles from './customiseErrorBoundaryStyles';
import { useHistory } from 'react-router';
import { ROUTES } from '../../../../common/constants/routes';
import { useUrlPersistentPostcode } from '../../../../gqlCommon/hooks/useUrlPersistentPostcode';
import { ISpcTheme } from '../../../../common/theme/ISpcTheme';
import useCustomizeCarContext from '../../../hooks/useCustomizeCarContext';

const CustomiseErrorBoundary: FC<any> = ({ children }) => {
  const styles = customiseErrorBoundaryStyles();
  const { error } = useCustomizeCarContext();
  const history = useHistory();
  const { getUrlPostcode, setUrlPostcode } = useUrlPersistentPostcode();
  const postcode = getUrlPostcode();
  const {
    spc: {
      customise: { displayErrorBoundaryBackButton },
    },
  } = useTheme<ISpcTheme>();

  const onClickBackButton = () => {
    history.push(ROUTES.MODELS);
    if (postcode) {
      setUrlPostcode(postcode);
    }
  };

  if (error) {
    return (
      <Box className={styles.container}>
        <ThemedErrorMessage
          fullPage={true}
          message={'trans__configurator__errors__configuration_error'}
          error={error}
        />
        {displayErrorBoundaryBackButton && (
          <Button
            className={styles.backButton}
            variant="contained"
            color="primary"
            data-test="button:backToModels"
            onClick={onClickBackButton}
          >
            <Translation id="trans__configurator__errors__configuration_error_back_cta" />
          </Button>
        )}
      </Box>
    );
  }

  return children;
};

export default CustomiseErrorBoundary;
